import type {PaletteMode} from '@mui/material';

export const getOutlinedBorderColor = (mode: PaletteMode = 'light') => {
	// Need our outlined input border colors to meet minimum contrast
	return mode === 'light' ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.38)';
};
